import {
    AddTagInput,
    AddTagResponse,
    GetAllTagsResponse,
    PutTagInput,
    PutTagResponse,
} from "../../../types/api/admin/tag";
import { request } from "../../apiService";

export const getAllTags = async () => {
    return await request<GetAllTagsResponse>(`/v3/admin/tags`);
};

export const getTagsByUser = async (userId: string) => {
    return await request<GetAllTagsResponse>(`/v3/admin/users/${userId}/tags`);
};

export const addTagsToUsers = async (userIds: string[], tagIds: string[]) => {
    return await request<void>(`/v3/admin/users/tags/bulk/add`, {
        method: "POST",
        input: { userIds, tagIds },
    });
};

export const removeTagsFromUsers = async (
    userIds: string[],
    tagIds: string[]
) => {
    return await request<void>(`/v3/admin/users/tags/bulk/remove`, {
        method: "DELETE",
        input: { userIds, tagIds },
    });
};

export const addTag = async (input: AddTagInput) => {
    return await request<AddTagResponse, AddTagInput>(`/v3/admin/tags`, {
        method: "POST",
        input,
    });
};

export const updateTag = async (id: string, input: PutTagInput) => {
    return await request<PutTagResponse, PutTagInput>(`/v3/admin/tags/${id}`, {
        method: "PUT",
        input,
    });
};

export const deleteTag = async (id: string) => {
    return await request<void>(`/v3/admin/tags/${id}`, {
        method: "DELETE",
    });
};
